module.exports = __webpack_public_path__ + "static/media/5levelEveryLow.8b249bb7.jpg";